import { useState } from 'preact/hooks';
import { GET, GET_MODEL_BRAND } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { useMutation } from '@tanstack/react-query';

export const useGetModel = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearch } = useMutation({
    mutationFn: async (values) => {
      const response = await GET(GET_MODEL_BRAND(values.search));
      return response.result?.items || [];
    },
    onSuccess: (response) => {
      setData(
        response.map((item) => ({
          ...item,
          mobileModelStatus: item.mobileModelStatus === 'ACTIVE',
        })),
      );
    },
    onError: () => {
      openAlert({
        model: 'message',
        type: 'error',
        message: 'กรุณาเลือกข้อมูลให้ถูกต้อง',
      });
    },
  });

  const onFetch = () =>
    handleSubmit((values) => {
      return onSearch(values);
    })();

  return { dataSource: data, setData, onSearch, loading: isPending, onFetch };
};
